export default "__VITE_ASSET__DVhqyugG__"